module.exports = __webpack_public_path__ + "static/media/phone_wait.5552c0ac.svg";